import React from "react";
import { logo, footerbg } from "../Assets";
import { FaDiscord, FaXTwitter } from "react-icons/fa6";

const Footer = () => {

  return (
    <footer
      className="w-full bg-cover bg-center text-white px-6 py-24"
      style={{ backgroundImage: `url(${footerbg})` }}
    >
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center md:items-start gap-12 text-center md:text-left">
        <div className="space-y-6 flex flex-col items-center md:items-start justify-center text-center md:text-left">
          <img src={logo} alt="Logo" className="w-40 sm:w-52 md:w-60" />
          <div className="flex flex-wrap justify-center items-center gap-4">
            <a href="discord.gg/Monadscore" target="_blank" rel="noreferrer">
              <FaDiscord className="w-6 h-6 text-[#06FF3C]" />
            </a>
            <a href="https://x.com/molundra" target="_blank" rel="noreferrer">
              <FaXTwitter className="w-6 h-6 text-[#06FF3C]" />
            </a>
          </div>
        </div>
        <div>
          <p className="text-base sm:text-sm uppercase leading-relaxed text-center md:text-right">
            Those who hear the code stirring...<br />Are already part of it.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;